import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import slide1 from "../assets/images/slide1-min.jpeg";
import slide2 from "../assets/images/slide2-min.jpeg";
import slide3 from "../assets/images/slide3-min.jpeg";
import { Box, Typography, Button } from "@mui/material";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Slider = () => {
  const navigate = useNavigate();
  const slides = [
    {
      image: slide1,
      layers: [
        {
          text: "El futuro de nuestro",
          style: {
            fontSize: { xs: "1.35rem", sm: "1.8rem", md: "3rem" },
            color: "#fff",
            top: { xs: "16%", md: "20%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          text: "planeta",
          style: {
            fontSize: { xs: "1.6rem", sm: "2.2rem", md: "4rem" },
            color: "#fff",
            top: { xs: "24%", md: "25%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          text: "está en nuestras",
          style: {
            fontSize: { xs: "1.35rem", sm: "1.8rem", md: "3rem" },
            color: "#fff",
            top: { xs: "34%", md: "33%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          text: "manos",
          style: {
            fontSize: { xs: "1.6rem", sm: "2.2rem", md: "4rem" },
            color: "#fff",
            top: { xs: "42%", md: "37%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          button: "Más Información",
          link: "/about-us",
          style: {
            top: { xs: "56%", md: "50%" },
            left: { xs: "6%", md: "10%" },
            backgroundColor: "warning.main",
            color: "#000",
            px: { xs: 2, md: 3 },
            py: { xs: 1, md: 1.5 },
            fontSize: { xs: "0.95rem", md: "1.25rem" },
            fontWeight: 700,
          },
        },
      ],
    },
    {
      image: slide2,
      layers: [
        {
          text: "Nuestro planeta",
          style: {
            fontSize: { xs: "1.6rem", sm: "2.2rem", md: "4rem" },
            color: "#fff",
            top: { xs: "18%", md: "20%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          text: "nos necesita",
          style: {
            fontSize: { xs: "1.35rem", sm: "1.8rem", md: "3rem" },
            color: "#fff",
            top: { xs: "32%", md: "30%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black",
          },
        },
        {
          button: "Más Información",
          link: "/about-us",
          style: {
            top: { xs: "47%", md: "40%" },
            left: { xs: "6%", md: "10%" },
            backgroundColor: "warning.main",
            color: "#000",
            px: { xs: 2, md: 3 },
            py: { xs: 1, md: 1.5 },
            fontSize: { xs: "0.95rem", md: "1.25rem" },
            fontWeight: 700,
          },
        },
      ],
    },
    {
      image: slide3,
      layers: [
        {
          text: "Menos basura,",
          style: {
            fontSize: { xs: "1.6rem", sm: "2.3rem", md: "5rem" },
            color: "#fff",
            top: { xs: "22%", md: "20%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black"
          },
        },
        {
          text: "más naturaleza",
          style: {
            fontSize: { xs: "1.6rem", sm: "2.3rem", md: "5rem" },
            color: "#fff",
            top: { xs: "34%", md: "30%" },
            left: { xs: "6%", md: "10%" },
            textShadow: "0.1em 0.1em 0.2em black"
          },
        },
      ],
    },
  ];

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      style={{ width: "100%", height: "clamp(360px, 70vh, 760px)" }}
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundImage: `url(${slide.image})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              "&::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                background: "linear-gradient(90deg, rgba(0,0,0,0.45), rgba(0,0,0,0.15))",
              },
            }}
          >
            {slide.layers.map((layer, idx) =>
              layer.button ? (
                <Button
                  key={idx}
                  variant="contained"
                  color="primary"
                  onClick={() => layer.link && navigate(layer.link)}
                  sx={{
                    position: "absolute",
                    ...layer.style,
                    zIndex: 1,
                    maxWidth: { xs: "88%", md: "70%" },
                  }}
                >
                  {layer.button}
                </Button>
              ) : (
                <Typography
                  key={idx}
                  sx={{
                    position: "absolute",
                    ...layer.style,
                    zIndex: 1,
                    maxWidth: { xs: "88%", md: "70%" },
                    fontWeight: 700,
                    lineHeight: 1.15,
                  }}
                >
                  {layer.text}
                </Typography>
              )
            )}
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Slider;
